import { Box, Text, Heading, theme, Container } from '@everlywell/ui-kit';
import { GatsbyImage as Img } from 'gatsby-plugin-image';
import React from 'react';
import renderRichText, {
  ContentfulRichText,
} from 'utils/contentful/renderRichText';
import { IGatsbyImage } from 'utils/types';

// Types ----------

export interface GridCardProps {
  image: IGatsbyImage;
  title: string;
  description: ContentfulRichText;
  imageStyles?: React.CSSProperties;
}

// GridCard ------

const GridCard: React.FC<GridCardProps> = (props) => {
  const { image, title, description, imageStyles } = props;

  return (
    <Container size="fluid">
      {/* Image aspect ratio to be 3:2 from Figma design */}
      <Box borderRadius={'xl'} display="flex" marginBottom={6} width="100%">
        {/* Image as a component for screen readers */}
        <Box
          borderRadius={'xl'}
          aspectRatio="1.5"
          as={Img}
          image={image.gatsbyImageData}
          alt={title}
          objectFit="fill"
          sx={imageStyles}
        />
      </Box>
      <Heading size="sm" marginBottom={theme.space[2]}>
        {title}
      </Heading>
      <Text size="lg" as="div">
        {renderRichText(description)}
      </Text>
    </Container>
  );
};

// Export ---------

export default React.memo(GridCard);
